/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnitCostDto } from '../../models/unit-cost-dto';

export interface GetUnitCost$Params {
  id: string;
}

export function getUnitCost(http: HttpClient, rootUrl: string, params: GetUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostDto>> {
  const rb = new RequestBuilder(rootUrl, getUnitCost.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnitCostDto>;
    })
  );
}

getUnitCost.PATH = '/v0/unitCosts/{id}';
